import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/Services/ElectricalPage/ElectricalPage.tsx");
